import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputHasAtLeatOneUpperCaseErrorMessage = (
  <Trans>
    Ce champ doit contenir un caractère majuscule
  </Trans>
);
